'use client';

import { addTimezoneToCalUrl } from '@/lib/calendar-utils';

interface CalendarLinkProps {
	href: string;
	children: React.ReactNode;
	className?: string;
	target?: string;
}

export default function CalendarLink({ href, children, className, target }: CalendarLinkProps) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		const urlWithTimezone = addTimezoneToCalUrl(href);

		if (target === '_blank') {
			window.open(urlWithTimezone, '_blank');
		} else {
			window.location.href = urlWithTimezone;
		}
	};

	return (
		<a
			href={href} // Static href for SSR
			className={className}
			onClick={handleClick}
			target={target}
		>
			{children}
		</a>
	);
}
